import React from "react";
import { SizeSelectFieldSize } from "./SizeSelectField";
import { Button } from "@glamcorner/components/lib/core/components/Button";
import { Header } from "@glamcorner/components/lib/core/components/Header";
import { Panel } from "@glamcorner/components/lib/core/components/Panel";

export interface SizeSelectPanelProps {
  sizes: SizeSelectFieldSize[];
  selectedSizeIds: Set<string>;
  onApply: () => void;
  onSelectSizeId: (sizeId: string) => void;
  onDeselectSizeId: (sizeId: string) => void;
  onClose: () => void;
}

export class SizeSelectPanel extends React.Component<SizeSelectPanelProps, {}> {
  constructor(props: SizeSelectPanelProps) {
    super(props);
  }

  render() {
    const { onClose, sizes, onApply } = this.props;
    const labelLength = (label: string) => (label.length > 3 ? "long" : "short");

    return (
      <Panel ready={true} className="c-panel--with-header c-panel--no-border">
        <Header onClick={onClose}>What is your size?</Header>
        <p>You can select more than one.</p>

        <div className="c-size-select-panel__sizes">
          {sizes.map(size => (
            <div
              key={size.sizeId}
              className={this.optionClassName(size)}
              data-value={size.sizeId}
              data-testid="size-select-panel-option"
              onClick={() => this.handleClickSize(size)}
            >
              {this.optionContent(size)}
              <p className={`c-size-select-panel__size-label--${labelLength(size.label)}`}>{size.label}</p>
            </div>
          ))}
        </div>

        <Button className="t-size-select-panel-apply c-size-select-panel__apply" onClick={onApply} text="Done" />
      </Panel>
    );
  }

  private optionClassName(size: SizeSelectFieldSize): string {
    return `t-option c-size-select-panel__option c-size-select-panel__option--${
      this.isSelected(size) ? "selected" : "unselected"
    }`;
  }

  private optionContent(size: SizeSelectFieldSize): React.ReactElement | null {
    return this.isSelected(size) ? this.renderTick() : null;
  }

  private renderTick(): React.ReactElement {
    return (
      <div className="c-size-select-panel__option-selected-tick">
        <img
          className="c-size-select-panel__option-selected-tick-img"
          alt="Selected Size Indicator"
          src="data:image/svg+xml;charset=utf-8;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDEwIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMuODk1NTggNy45NTcwMkMzLjc4NjA4IDguMDgwNzcgMy42NjI4OSA4LjE0MjY1IDMuNTI2MDIgOC4xNDI2NUMzLjM4OTE0IDguMTQyNjUgMy4yNjU5NSA4LjA4MDc3IDMuMTU2NDUgNy45NTcwMkwwLjg1NjkzNCA1LjM1ODNMMS41OTYwNiA0LjUyMjk5TDMuNTI2MDIgNi43MDQwN0w4LjY1ODg3IDAuODU2OTM0TDkuMzU2OTMgMS42OTIyNEwzLjg5NTU4IDcuOTU3MDJaIiBmaWxsPSIjMjMxRjIwIi8+DQo8L3N2Zz4="
        />
      </div>
    );
  }

  private isSelected(size: SizeSelectFieldSize) {
    return this.props.selectedSizeIds.has(size.sizeId);
  }

  private handleClickSize(size: SizeSelectFieldSize) {
    if (this.isSelected(size)) {
      this.props.onDeselectSizeId(size.sizeId);
    } else {
      this.props.onSelectSizeId(size.sizeId);
    }
  }
}
